/**
 * Configuration service request model.
 *
 * @param {Object} state Data model object
 * @param {string} state.database
 * @param {string} state.password
 * @param {string} state.server
 * @param {string} state.username
 */

const request = state => ({
  DatabaseName: state.database,
  Password: state.password,
  Server: state.server,
  Username: state.username,
});

export default {
  request,
};
